import type { PropsWithChildren, ReactNode } from "react";

import PlausibleProvider, { usePlausible } from "next-plausible";

import type { PlausibleEvents } from "@/src/infrastructure/plausible/PlausibleEvents";

export function TrackingProvider({ children }: PropsWithChildren): ReactNode {
  return (
    <PlausibleProvider
      init={{
        captureOnLocalhost: false, // Enable this if you want to test locally
        fileDownloads: { fileExtensions: ["pdf"] },
      }}
    >
      {children}
    </PlausibleProvider>
  );
}

export const useTracking = usePlausible<PlausibleEvents>;
